import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=0daeb2a0&scoped=true&"
import script from "./GroupModal.vue?vue&type=script&lang=js&"
export * from "./GroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daeb2a0",
  null
  
)

export default component.exports